import React, {useEffect} from 'react';
import { Card } from "antd";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { Button } from 'antd';

import kopernikcodeLogo from '../kopernik-code-logo.png';
import kzuLogo from "../kzu.png";
import ibLogo from "../iblogo.png";
import schoolLogo from "../school.png";
import peopleLogo from "../people.png";
import languageLogo from "../language.png";
import certLogo from "../cert.png";
import logoSmall from '../logo-small.png';
import officeLogo from '../office.png';


const WhyUs = () => {
    gsap.registerPlugin(ScrollTrigger);
    useEffect(() => {
        gsap.from('.h1why', {
            y: -50,
            opacity: 0,
            scrollTrigger: '.why-us'
        })
        gsap.from('.whyUsElm', {
            y: 50,
            duration: 1,
            opacity: 0, 
            delay: 1, 
            stagger: 0.3,
            ease: 'power3',
            scrollTrigger: '.why-us'
        })

    }, [])
    const data = [
        {
            title: 'Nauka programowania',
            description: 'Dzięki naszym metodom nauczania w ciekawy sposób poznasz podstawy programowania. Osoby chętne przygotowujemy do zdawania matury z informatyki. Zapewniamy również naukę takich języków programowania jak Python czy Swift. Jesteśmy częścią Klastra IT Leszno, dzięki czemu uczniowie mają kontakt z firmami programistycznymi.',
            img: kopernikcodeLogo,
            url: 'http://code.kopernik-leszno.pl/'
        },
        {
            title: 'Klasa IB',
            description: 'Program jest adresowany do uczennic/uczniów zdolnych, ambitnych, zmotywowanych, z dobrą znajomością języka angielskiego, chcących rozwijać swoje pasje i zainteresowania, otwartych, dociekliwych, komunikatywnych, myślących, refleksyjnych, wrażliwych społecznie i tolerancyjnych wobec ludzi różnych przekonań, światopoglądów, religii, ras i narodowości.',
            img: ibLogo,
            url: 'http://ib.kopernik-leszno.pl/news/c-10/ib-news'
        },
        {
            title: 'Współpraca z uczelniami',
            description: 'Szkoła współpracuje z uczelniami wyższymi takimi jak Uniwersytet im. Adama Mickiewicza w Poznaniu, Uniwersytet Medyczny im. Karola Marcinkowskiego w Poznaniu, Szkoła Główna Handlowa w Warszawie, Politechnika Wrocławska.',
            img: schoolLogo
        },
        {
            title: 'Dwujęzyczność',
            description: 'W naszej szkole dużą wagę przykładamy do nauki języka angielskiego - realizujemy to dzięki wysoko wykwalifikowanej kadrze nauczycielskiej, zwiększonej ilości godzin nauki języka, jak również poprzez lekcje prowadzone dwujęzycznie.',
            img: languageLogo
        },
        {
            title: 'Egzaminy językowe',
            description: 'W naszej szkolne przygotowujemy i umożliwiamy zdawanie egzaminów językowych Cambridge English Qualifications oraz Deutsches Sprachdiplom, które honorowane są na arenie międzynarodowej.',
            img: certLogo
        },
        {
            title: 'Wolontariat',
            description: 'Szkoła umożliwia rozwijanie umiejętności społecznych młodzieży poprzez możliwość uczestnictwa w różnego rodzaju akcjach charytatywnych.',
            img: peopleLogo,
        },
        {
            title: 'Koła zainteresowań',
            description: 'Chętnym uczniom dajemy możliwość rozwiajania swoich pasji. Działają u nas koła skierowane m.in. do zwolenników nauk biologiczno-chemicznych, "ścisłowców", humanistów czy pasjonatów informatyki.',
            img: logoSmall
        },
        {
            title: 'Klub Zdolnego Ucznia',
            description: 'Klub Zdolnego Ucznia to autorski projekt skierowany do uczniów klas 7 i 8 szkoły podstawowej. Ma na celu skupienie młodzieży chętnej do poszerzania swojej wiedzy i umiejętności w takich dyscyplinach naukowych jak np. matematyka, informatyka, język angielski, biologia, chemia, fizyka, historia.',
            img: kzuLogo,
            url: 'http://kzu.kopernik-leszno.pl/'
        },
        {
            title: 'Zaplecze dydaktyczne i nie tylko',
            description: 'Do dyspozycji uczniów są dobrze wyposażone pracownie przedmiotowe pozwalające na naukę połączoną z doświadczeniami i wykorzystaniem narzędzi elektronicznych. Na terenie szkoły znajdują się też boiska sportowe i tereny rekreacyjne. Uczniowie mogą również skorzystać ze szkolnej stołówki.',
            img: officeLogo
        }
    ]
        
    return(
        <div className='whyUs'>
            <div className='whyUsContent'>
                <h1 className='h1Large white h1why'>Dlaczego nasza szkoła?</h1>
                <div className='whyUsElms'>
                    {data.map(i =>
                        <Card
                            className='whyUsElm'
                            key={i.title}
                            style={{ width: 300 }}
                            cover={
                                <di className='cardImgDiv'>
                                    <img
                                        alt='img'
                                        src={i.img}
                                    /> 
                                </di>

                            }
                        >
                            <h1 style={{lineHeight: 1, textAlign: 'left'}}>{i.title}</h1>
                            <p style={{fontSize: 15}}>{i.description}</p>
                            <br></br>
                            {i.url !== undefined &&
                                <Button href={i.url} target='_blank' className='cardBtn' size="large" type="primary">Zobacz więcej</Button>
                            }
                        </Card> 
                    )}

                </div>
            </div>

        </div>
    )
}
export default WhyUs;